
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Error404">
    <b-card
      class="border-0 border-raduis-xl box-shadow-sm h-100 mt-5"
      body-class="d-flex align-items-center justify-content-center py-5 bg-logo"
      style="min-height: calc(100vh - 200px)"
    >
     <div class="text-center">
        <h2 class="mb-4 font-weight-light font-40px">La page demandée n'existe pas.</h2>
      <p class="mb-3 h5 font-weight-light">Vérifiez votre URL ou rendez-vous sur notre page d'accueil</p>
      <p class="mb-0 h5 font-weight-light">Vous avez besoin d'accéder à Gigawhat ?</p>
      <p class="mb-0 h5 font-weight-light">Se connecter ou inscrivez-vous</p>
     </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Error404',
  components: {},
  computed: {},
  methods: {},
};
</script>
